/* Pensum — Ergänzungen zu theme.js
   Läuft eigenständig und braucht nichts aus theme.js. */
(function () {
  'use strict';

  /* ------------------------------------------------------------- Kopfzeile */

  // Beim Herunterscrollen fährt die Kopfzeile weg, beim Hochscrollen ist sie
  // sofort wieder da. Ganz oben bleibt sie immer stehen.
  function initHeader() {
    // Klebend ist der Sektions-Wrapper, nicht das <header> selbst — siehe die
    // Begründung in pensum.css. Die Klasse muss also dort landen.
    var inner = document.querySelector('.header--sticky');
    if (!inner) return;

    var header = inner.closest('.shopify-section--header') || inner;

    var letzte = window.pageYOffset || 0;
    var geplant = false;

    // Ohne Schwelle flackert die Kopfzeile bei jedem Ruckeln und beim Federn
    // am Seitenende. Der Freiraum hält sie im obersten Bereich sichtbar.
    var SCHWELLE = 6;
    var FREIRAUM = 90;

    function pruefen() {
      geplant = false;

      var jetzt = window.pageYOffset || 0;
      var diff = jetzt - letzte;

      if (Math.abs(diff) < SCHWELLE) return;

      if (jetzt < FREIRAUM || diff < 0) {
        header.classList.remove('header--tucked');
      } else {
        header.classList.add('header--tucked');
      }

      letzte = jetzt;
    }

    window.addEventListener('scroll', function () {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(pruefen);
    }, { passive: true });

    // Ist das Menü offen, darf die Kopfzeile nicht wegfahren — sonst
    // verschwindet der Schließen-Knopf mit ihr.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-menu-open]')) {
        header.classList.remove('header--tucked');
      }
    });
  }

  /* --------------------------------------------------------- Menü-Schublade */

  // Die Kopfzeile wird zum Wegfahren per transform verschoben. Ein Vorfahre mit
  // transform wird aber zum Bezugsrahmen für position: fixed — und die
  // Schublade liegt im Markup des Kopfbereich-Abschnitts. Ihr `inset: 0` galt
  // dadurch nicht mehr für den Bildschirm, sondern für die Kopfzeile: Sie
  // erschien als schmaler Streifen oben statt bildschirmhoch von rechts.
  //
  // Deshalb wird sie direkt an <body> gehängt. Dort gibt es keinen
  // transformierten Vorfahren mehr.
  function drawerLoesen() {
    var drawer = document.getElementById('MenuDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  /* ----------------------------------------------------------- Druckvorlage */

  /* Hängt an jede personalisierte Bestellung eine Zeile „Druckvorlage" mit
     einem Link. Der Link öffnet /pages/druckvorlage und zeigt dort das
     Produktfoto mit dem Aufdruck an genau der Stelle, die der Kunde gewählt
     hat — damit in der Bestellung nicht nur Prozentzahlen stehen.

     Alle Werte werden aus dem bestehenden Seitenzustand gelesen. personalizer.js
     bleibt unangetastet: die versteckten Bestellfelder und die CSS-Variablen der
     Ebenen enthalten schon alles, was gebraucht wird. */

  function initDruckvorlage() {
    var root = document.querySelector('[data-pz]');
    if (!root) return;

    var formId = root.getAttribute('data-pz-form');
    var stage = root.querySelector('[data-pz-stage]');
    var photo = root.querySelector('[data-pz-photo]');
    var textLayer = root.querySelector('[data-pz-layer="text"]');
    var symbolLayer = root.querySelector('[data-pz-layer="symbol"]');
    if (!stage || !textLayer) return;

    function feld(name) {
      return root.querySelector('[data-pz-prop="' + name + '"]');
    }

    // Eigenes Feld, damit personalizer.js seine eigenen Felder weiter frei
    // verwaltet. Der Unterstrich hält die Zeile aus der Kundenansicht heraus:
    // im Warenkorb und in der Bestätigungsmail erscheint sie nicht, im
    // Adminbereich schon.
    var ziel = document.createElement('input');
    ziel.type = 'hidden';
    ziel.name = 'properties[_Druckvorlage]';
    ziel.setAttribute('data-pz-vorlage', '');
    ziel.disabled = true;
    if (formId) ziel.setAttribute('form', formId);
    root.appendChild(ziel);

    // Nur der Dateiname wandert in den Link; die Adresse davor setzt die
    // Vorlagenseite wieder zusammen. Sonst wird der Wert unnötig lang.
    function bilddatei() {
      if (!photo || photo.hidden || !photo.getAttribute('src')) return '';
      var pfad = photo.getAttribute('src').split('?')[0];
      return pfad.substring(pfad.lastIndexOf('/') + 1);
    }

    function prozent(el, name) {
      var wert = getComputedStyle(el).getPropertyValue(name).trim();
      var zahl = parseFloat(wert);
      return isNaN(zahl) ? null : Math.round(zahl * 10) / 10;
    }

    // Die Schriftgröße steht in px und bezieht sich auf die Bühnenbreite. Als
    // Anteil der Breite gilt sie auf der Vorlagenseite unabhängig davon, wie
    // groß das Bild dort dargestellt wird.
    function groesseAnteil(el) {
      var breite = stage.clientWidth;
      if (!breite) return null;
      var fs = parseFloat(getComputedStyle(el).getPropertyValue('--pz-fs'));
      if (isNaN(fs)) return null;
      var skala = parseFloat(getComputedStyle(el).getPropertyValue('--pz-layer-scale')) || 1;
      return Math.round((fs * skala / breite) * 1000) / 10;
    }

    function schrift(el) {
      var stapel = getComputedStyle(el).getPropertyValue('--pz-font').trim();
      // Nur der erste Name wird gebraucht — die Vorlagenseite kennt dieselben
      // Familien und hängt ihre eigenen Ausweichschriften an.
      return stapel.split(',')[0].replace(/["']/g, '').trim();
    }

    function bauen() {
      var textFeld = feld('text');
      var text = textFeld ? textFeld.value : '';
      var symbolFeld = feld('symbolchar');
      var zeichen = symbolFeld && !symbolFeld.disabled ? symbolFeld.value : '';

      // Ohne Aufdruck und ohne Zeichen gibt es nichts zu drucken.
      if (!text && !zeichen) {
        ziel.value = '';
        ziel.disabled = true;
        return;
      }

      var inkFeld = feld('inkhex');
      var teile = [];

      function setze(schluessel, wert) {
        if (wert === null || wert === undefined || wert === '') return;
        teile.push(schluessel + '=' + encodeURIComponent(wert));
      }

      setze('b', bilddatei());
      setze('t', text);
      setze('f', schrift(textLayer));
      setze('i', inkFeld ? String(inkFeld.value).replace('#', '') : '');
      setze('x', prozent(textLayer, '--pz-layer-x'));
      setze('y', prozent(textLayer, '--pz-layer-y'));
      setze('z', groesseAnteil(textLayer));
      setze('l', getComputedStyle(textLayer).getPropertyValue('--pz-track').trim());

      if (zeichen && symbolLayer && !symbolLayer.hidden) {
        setze('s', zeichen);
        setze('sf', schrift(symbolLayer));
        setze('sx', prozent(symbolLayer, '--pz-layer-x'));
        setze('sy', prozent(symbolLayer, '--pz-layer-y'));
        setze('sz', groesseAnteil(symbolLayer));
      }

      ziel.value = window.location.origin + '/pages/druckvorlage#' + teile.join('&');
      ziel.disabled = false;
    }

    // personalizer.js schreibt seine Felder bei jeder Änderung neu. Statt dessen
    // Ablauf nachzubauen, wird hier auf genau diese Schreibvorgänge gehört.
    var beobachter = new MutationObserver(function () { bauen(); });
    ['text', 'inkhex', 'textlayout', 'symbolchar', 'symbollayout'].forEach(function (name) {
      var el = feld(name);
      if (el) beobachter.observe(el, { attributes: true, attributeFilter: ['value', 'disabled'] });
    });

    // Attributänderungen greifen nicht, wenn der Wert über die Eigenschaft
    // gesetzt wird — deshalb zusätzlich auf die sichtbaren Auslöser hören.
    root.addEventListener('input', bauen);
    root.addEventListener('click', function () { window.setTimeout(bauen, 0); });
    root.addEventListener('pointerup', function () { window.setTimeout(bauen, 0); });
    document.addEventListener('change', function () { window.setTimeout(bauen, 60); });

    bauen();
  }

  function boot() {
    drawerLoesen();
    initHeader();
    initDruckvorlage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Im Theme-Editor wird der Kopfbereich neu gezeichnet, dabei entsteht die
  // Schublade wieder an ihrem alten Platz. Also nochmal umhängen.
  document.addEventListener('shopify:section:load', function () {
    drawerLoesen();
  });
})();
